// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobileCutomPaddingNotif .b-dropdown-text[data-v-5e09f06d]{padding:0!important}", ""]);
// Exports
module.exports = exports;
